import {WwsUmsatzstatistikOptionenListStore} from './abstractions/optionen-list.store';

export const WwsUmsatzstatistikAufgliederungStore = new WwsUmsatzstatistikOptionenListStore<{ name: string; umsatzaufgliederung: string }>()
